const compatModules = {};import * as Mod1 from "./discourse/connectors/composer-action-after/reply-as-staff-alias-icon.gjs";
compatModules["discourse/connectors/composer-action-after/reply-as-staff-alias-icon"] = Mod1;

export * as discourse$connectors$composer__action__after$reply__as__staff__alias__icon$$__module from "./discourse/connectors/composer-action-after/reply-as-staff-alias-icon.gjs";
export {
default as discourse$connectors$composer__action__after$reply__as__staff__alias__icon$$default
} from "./discourse/connectors/composer-action-after/reply-as-staff-alias-icon.gjs";
import * as Mod2 from "./discourse/connectors/revision-user-details-after/aliased-staff-user-details.gjs";
compatModules["discourse/connectors/revision-user-details-after/aliased-staff-user-details"] = Mod2;

export * as discourse$connectors$revision__user__details__after$aliased__staff__user__details$$__module from "./discourse/connectors/revision-user-details-after/aliased-staff-user-details.gjs";
export {
default as discourse$connectors$revision__user__details__after$aliased__staff__user__details$$default
} from "./discourse/connectors/revision-user-details-after/aliased-staff-user-details.gjs";
import * as Mod3 from "./discourse/initializers/discourse-staff-alias";
compatModules["discourse/initializers/discourse-staff-alias"] = Mod3;

export * as discourse$initializers$discourse__staff__alias$$__module from "./discourse/initializers/discourse-staff-alias";
export {
default as discourse$initializers$discourse__staff__alias$$default
} from "./discourse/initializers/discourse-staff-alias";
export default compatModules;
